import '../../assets/components/Typography/Typography.css';//#region lib/components/Typography/Typography.module.css
var e = "_caption_1aibv_74", t = "_regular_1aibv_82", n = "_medium_1aibv_86", r = "_aligned_1aibv_91", i = {
	"display-extra-large": "_display-extra-large_1aibv_4",
	"display-large": "_display-large_1aibv_11",
	"display-medium": "_display-medium_1aibv_18",
	"display-small": "_display-small_1aibv_25",
	"heading-large": "_heading-large_1aibv_32",
	"heading-medium": "_heading-medium_1aibv_39",
	"heading-small": "_heading-small_1aibv_46",
	"body-small": "_body-small_1aibv_53",
	"body-medium": "_body-medium_1aibv_60",
	"body-large": "_body-large_1aibv_67",
	caption: e,
	regular: t,
	medium: n,
	aligned: r
};
//#endregion
export { r as aligned, e as caption, i as default, n as medium, t as regular };
